/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundBillReqVo
 */
export interface RefundBillReqVo {
    /**
     * 订单编码
     * @type {string}
     * @memberof RefundBillReqVo
     */
    orderCode: string;
    /**
     * 账单类型
     * @type {number}
     * @memberof RefundBillReqVo
     */
    billType: number;
}

/**
 * Check if a given object implements the RefundBillReqVo interface.
 */
export function instanceOfRefundBillReqVo(value: object): value is RefundBillReqVo {
    if (!('orderCode' in value) || value['orderCode'] === undefined) return false;
    if (!('billType' in value) || value['billType'] === undefined) return false;
    return true;
}

export function RefundBillReqVoFromJSON(json: any): RefundBillReqVo {
    return RefundBillReqVoFromJSONTyped(json, false);
}

export function RefundBillReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundBillReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'],
        'billType': json['billType'],
    };
}

export function RefundBillReqVoToJSON(json: any): RefundBillReqVo {
    return RefundBillReqVoToJSONTyped(json, false);
}

export function RefundBillReqVoToJSONTyped(value?: RefundBillReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'billType': value['billType'],
    };
}

